import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MultipleChoice,
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { responseMultipleChoicesQueryKeys } from './queryKeys'

/**
 * 従来の選択肢（他のひな形でも使用中）を追加する
 */
export const useMutationAddMultipleChoices = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      multipleChoices: MultipleChoice[],
    ): Promise<MultipleChoiceGroup> => {
      return await baseClient
        .getApi(TemplatesApi)
        .addResponseMultipleChoices({
          multipleChoice: multipleChoices,
        })
        .catch(handleHTTPError)
    },
    onSuccess: (newGroup: MultipleChoiceGroup) => {
      queryClient.setQueryData<MultipleChoiceGroup[]>(
        responseMultipleChoicesQueryKeys.all,
        (old = []) => [...old, newGroup],
      )
    },
  })
}
